import React, { useState } from "react";
import { FaChartArea, FaChartBar, FaWallet, FaMobileAlt, FaLock, FaExchangeAlt, FaUsers, FaGlobe, FaShieldAlt, FaCogs, FaTachometerAlt, FaUserShield, FaCoins, FaReceipt, FaBell, FaFileAlt, FaSlidersH, FaDatabase, FaBan, FaPlug } from "react-icons/fa";

const tabs = [
  { label: "Exchange Features", key: "exchange" },
  { label: "Admin Panel Features", key: "admin" },
];

const features = {
  exchange: [
    { icon: <FaChartArea size={28} />, title: "Spot Trading Module" },
    { icon: <FaChartBar size={28} />, title: "Advanced Charting" },
    { icon: <FaWallet size={28} />, title: "Multi-Currency Wallet" },
    { icon: <FaMobileAlt size={28} />, title: "Mobile APP" },
    { icon: <FaLock size={28} />, title: "Crypto Staking" },
    { icon: <FaExchangeAlt size={28} />, title: "Fiat-to-Crypto" },
    { icon: <FaUsers size={28} />, title: "P2P Trading" },
    { icon: <FaGlobe size={28} />, title: "Multi-Language" },
    { icon: <FaShieldAlt size={28} />, title: "Advanced KYC/AML" },
    { icon: <FaCogs size={28} />, title: "Cross-chain Swaps" },
  ],
  admin: [
    { icon: <FaTachometerAlt size={28} />, title: "Dashboard Analytics" },
    { icon: <FaUserShield size={28} />, title: "User Management" },
    { icon: <FaCoins size={28} />, title: "Token Management" },
    { icon: <FaReceipt size={28} />, title: "Fee Configuration" },
    { icon: <FaBell size={28} />, title: "Push Notifications" },
    { icon: <FaFileAlt size={28} />, title: "Compliance Reports" },
    { icon: <FaSlidersH size={28} />, title: "Liquidity Settings" },
    { icon: <FaDatabase size={28} />, title: "Order Book Control" },
    { icon: <FaBan size={28} />, title: "Fraud Detection" },
    { icon: <FaPlug size={28} />, title: "API Management" },
  ],
};

function CryptoFeatures() {
  const [activeTab, setActiveTab] = useState("exchange");

  return (
    <div style={{ padding: "80px 0", background: "#f7f9fc" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold" style={{ color: "#0a1f44", fontSize: "clamp(24px, 3vw, 38px)" }}>
            Features You Get With Crypto Exchange
          </h2>
          <p className="text-muted mx-auto" style={{ maxWidth: "650px" }}>
            Our cryptocurrency exchange solution comes packed with everything you need to run a professional trading platform.
          </p>
        </div>

        {/* Tabs */}
        <div className="d-flex justify-content-center gap-3 mb-5 flex-wrap">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className="ce-tab-btn"
              style={{
                background: activeTab === tab.key ? "#0a1f44" : "#fff",
                color: activeTab === tab.key ? "#fff" : "#0a1f44",
                border: activeTab === tab.key ? "2px solid #0a1f44" : "2px solid #e2e8f0",
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Feature Grid */}
        <div className="row g-4">
          {features[activeTab].map((feat, idx) => (
            <div className="col-lg-3 col-md-4 col-6" key={idx}>
              <div className="ce-feature-card">
                <div className="ce-feature-icon d-flex align-items-center justify-content-center">
                  {feat.icon}
                </div>
                <p className="fw-semibold mb-0" style={{ fontSize: "14px", color: "#0a1f44" }}>{feat.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CryptoFeatures;
